module.exports = __webpack_public_path__ + "static/media/signInWithSlack.f2d272f8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SignInWithSlackButton/signInWithSlack.svg
 ** module id = 617
 ** module chunks = 0
 **/